import { motion } from "framer-motion";
import { processProps } from "../utils/interfaces";

const ProcessCard = ({ src, txt, alt }: processProps) => {
  return (
    <motion.div
      className="w-full flex justify-center"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex flex-col 800:flex-row items-center max-w-[293px] hover:border-primary-500 hover:border-2 gap-1 400:gap-2 border-2 border-neutral-700/50 rounded-xl 1100:px-p30 1100:py-p30 600:px-5 600:py-p30 py-1.5 px-2 400:px-3 bg-gradient-to-br from-neutral-800/90 to-neutral-900/90 hover:from-neutral-800 hover:to-neutral-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-primary-500/20 backdrop-blur-sm">
        <motion.img
          src={src}
          alt={alt}
          className="1100:w-10 1100:h-10 w-4 400:w-5 h-5 500:w-7 500:h-7"
          whileHover={{ rotate: [0, -10, 10, -10, 0] }}
          transition={{ duration: 0.5 }}
        />
        <p className="text-[10px] 400:text-xs 500:text-base text-center 1100:text-xl font-poppins-semi-bold text-neutral-200 group-hover:text-primary-400 transition-colors duration-300">
          {txt}
        </p>
      </div>
    </motion.div>
  );
};

export default ProcessCard;
